import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiRoutes } from '../api-routes.config';
import { getApiServiceUrl } from '../api-utils';

import { ApiService } from 'projects/admin/src/app/core/services/http/api.service';
import { MasterListType } from 'projects/admin/src/app/shared/configs/master-list-type.config';
import { ApiResponse } from 'projects/admin/src/app/shared/models/api-response';
import { MasterListsObj } from 'projects/admin/src/app/shared/models/master-list';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService extends ApiService {
  fetchMasterLists(masterListTypeList: MasterListType[]): Observable<MasterListsObj> {
    const masterListTypeParameterList: string[] = masterListTypeList.map(
      (masterListType) => `list_models[]=${masterListType}`,
    );

    return this.get<MasterListsObj>(
      `${
        this.apiUrl.commonService
      }/public/api/v1/get-master-list?${masterListTypeParameterList.join('&')}`,
    );
  }

  fetchAllAssessments(
    page: number,
    limit: number,
    sort: string | null,
    filters?: Record<string, any>,
  ): Observable<ApiResponse<any[]>> {
    return this.get<ApiResponse<any[]>>(`${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}`, {
      params: this.getQueryStringParameters({
        page,
        limit,
        sort,
        ...(filters ? this.convertToFilterParams(filters) : {}),
      }),
    });
  }

  fetchAssessment(assessmentId: string): Observable<ApiResponse<any>> {
    return this.get<ApiResponse<any>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}/${assessmentId}`,
    );
  }

  uploadAssessmentData(data: any): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.post<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}`,
      data,
      {
        headers,
      },
    );
  }

  uploadQuestions(data: any): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.post<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.question)}`,
      data,
      {
        headers,
      },
    );
  }
  uploadOptions(data: any): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.post<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.options)}`,
      data,
      {
        headers,
      },
    );
  }
  deleteQuestion(id: any): Observable<Pick<ApiResponse, 'url'>> {
    return this.delete<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.question)}/${id}`,
    );
  }

  deleteAssessment(id: any): Observable<Pick<ApiResponse, 'url'>> {
    return this.delete<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}/${id}`,
    );
  }
  editAssessment(data: any, id: any): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.patch<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}/${id}`,
      data,
      {
        headers,
      },
    );
  }
  editIndividualQuestion(data: any, id: any): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.patch<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessmentQuestion)}/${id}`,
      data,
      {
        headers,
      },
    );
  }

  updateAssessmentLockStatus(id: string, status: number): Observable<Pick<ApiResponse, 'url'>> {
    const headers = new HttpHeaders();

    return this.patch<Pick<ApiResponse, 'url'>>(
      `${getApiServiceUrl(ApiRoutes.appRoutes.pleAssessment)}/${id}/lock-status?status=${status}`,
      {},
      {
        headers,
      },
    );
  }
}

export { MasterListType };
